import { render } from "./BaseCheckBox.vue?vue&type=template&id=13209bc9"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"
script.render = render

export default script